import React from 'react';
import { TableRow } from './TableRow';
import { NoRows } from '../../../../layout/Table/NoRows';

function TableBody(props) {
  const { coupons, campaign_id, couponCreated } = props;
  const { setCouponUpdated } = props;

  const renderRows = () => {
    if (!Array.isArray(coupons) || coupons.length === 0) {
      return <NoRows colSpan="8"/>;
    }

    return coupons.map(renderRow);
  };

  const renderRow = (coupon, index) => {
    const { actionCallback } = props;

    return (
      <TableRow
        shouldRenderFields={ props.shouldRenderFields }
        key={ index }
        coupon={ coupon }
        actionCallback={ actionCallback }
        index= { index }
        campaign_id={ campaign_id }
        setCouponUpdated={ setCouponUpdated }
        couponCreated={ couponCreated }
      />
    )
  }
    return (
      <tbody>
      { renderRows() }
      </tbody>
    )
}

export { TableBody };
